<template>
  <div>
    <b-modal :title="name" v-model="showAssetPreview" hide-footer size="xl" centered scrollable>
      <div class="d-flex justify-content-center">
          <video-player v-if="isVideo"
                        :thumb-url="thumbUrl"
                        :url="previewUrl"/>

          <b-img v-else :src="previewUrl" fluid/>
      </div>
    </b-modal>

    <div @click="showAssetPreview = true"
         class="img-bg asset-avatar cursor-pointer"
         :class="{'asset-avatar-open': avatarOpen}"
         :style="imgStyle">

      <div v-if="loading"
           class="d-flex w-100 h-100 align-items-center justify-content-center">
        <pulse-loader :loading="loading === true"
                      size="10px"
                      color="#00C0F4"
                      class="mx-2"/>
      </div>

      <div class="asset-avatar-overlay position-absolute top-left">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader';
import VideoPlayer from "../Common/VideoPlayer";

export default {
  props: ['name', 'type', 'avatarOpen', 'previewUrl', 'thumbUrl', 'loading'],
  data: function () {
    return {
      showAssetPreview: false
    }
  },
  computed: {
    isVideo() {
      return this.type === "Video"
    },

    imgStyle: function () {
      if (!this.loading) {
        return `background-image: url(${this.thumbUrl})`
      }
    }
  },

  components: {PulseLoader, VideoPlayer}
}
</script>